<template>
  <div class="news-detail-page">
    <s-r-m-header activeVal="news" />

    <template v-if="currentNews">
      <section class="detail-hero">
        <div class="detail-header">
          <div class="breadcrumb pointer" @click="goBack">新闻资讯 / 返回列表</div>
          <h1>{{ currentNews.title }}</h1>
          <div class="publish-date">
            来源：{{ currentNews.source || '本站编辑' }}
            作者：{{ currentNews.author || '管理员' }}
            时间：{{ currentNews.publishDate }}
          </div>
        </div>
      </section>

      <main class="detail-container">
        <article class="news-content">
          <div
            v-for="(block, index) in currentNews.content"
            :key="`${block.type}-${index}`"
            class="content-block"
          >
            <p v-if="block.type === 'text'">{{ block.value }}</p>
            <div
              v-else-if="block.type === 'html'"
              class="html-block"
              v-html="block.value"
            ></div>
            <h2 v-else-if="block.type === 'heading'">{{ block.value }}</h2>
            <figure v-else-if="block.type === 'image'">
              <img :src="block.src" :alt="block.alt">
              <figcaption v-if="block.alt">{{ block.alt }}</figcaption>
            </figure>
          </div>
        </article>

        <div class="news-switch">
          <div
            class="switch-item switch-prev"
            :class="{ disabled: !prevNews }"
            @click="goNews(prevNews)"
          >
            <span class="switch-arrow">‹</span>
            <span class="switch-text">
              上一篇：
              <template v-if="prevNews">{{ prevNews.title }}</template>
              <template v-else>没有了</template>
            </span>
          </div>
          <div
            class="switch-item switch-next"
            :class="{ disabled: !nextNews }"
            @click="goNews(nextNews)"
          >
            <span class="switch-text">
              下一篇：
              <template v-if="nextNews">{{ nextNews.title }}</template>
              <template v-else>没有了</template>
            </span>
            <span class="switch-arrow">›</span>
          </div>
        </div>
      </main>
    </template>

    <main v-else class="empty-container">
      <h1>新闻不存在</h1>
      <p>当前访问的新闻不存在或已下线。</p>
      <button type="button" @click="goBack">返回新闻列表</button>
    </main>

    <footer-box />
  </div>
</template>

<script>
import SRMHeader from '@/components/SRMHeader/index'
import FooterBox from '@/components/FooterBox'
import newsList, { getNewsBySourceId } from '@/static/js/newsData'

export default {
  name: 'NewsDetail',
  components: {
    SRMHeader,
    FooterBox
  },
  metaInfo() {
    return {
      title: this.currentNews ? this.currentNews.title : '新闻详情'
    }
  },
  computed: {
    currentNews() {
      return getNewsBySourceId(this.$route.params.sourceId)
    },
    currentIndex() {
      return newsList.findIndex(item => item.sourceId === this.$route.params.sourceId)
    },
    prevNews() {
      if (this.currentIndex <= 0) return null
      return newsList[this.currentIndex - 1]
    },
    nextNews() {
      if (this.currentIndex < 0 || this.currentIndex >= newsList.length - 1) return null
      return newsList[this.currentIndex + 1]
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        name: 'newsList'
      })
    },
    goNews(news) {
      if (!news) return
      this.$router.push({
        name: 'newsDetail',
        params: { sourceId: news.sourceId }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.news-detail-page {
  min-height: 100vh;
  background: #fff;
}

.detail-hero {
  padding: 11.2rem 0 2.8rem;
  background: #fff;
}

.detail-header {
  width: 160rem;
  max-width: calc(100% - 3.2rem);
  margin: 0 auto;
  text-align: center;
}

.breadcrumb {
  display: inline-block;
  margin-bottom: 2.4rem;
  color: #999;
  font-size: 1.8rem;
}

.detail-header h1 {
  margin: 0 0 1.8rem;
  color: #222;
  font-size: 3.2rem;
  font-weight: 600;
  line-height: 1.6;
}

.publish-date {
  color: #999;
  font-size: 1.7rem;
  line-height: 1.8;
}

.detail-container {
  width: 160rem;
  max-width: calc(100% - 3.2rem);
  margin: 0 auto;
  padding: 2.4rem 0 7rem;
}

.news-content {
  padding: 4rem 5rem;
  background: #fff;
  border: .1rem solid #edf0f5;
  border-radius: 1.2rem;
  box-shadow: 0 .8rem 2.4rem rgba(31, 45, 61, .06);
}

.content-block {
  margin-bottom: 1.8rem;
}

.content-block:last-child {
  margin-bottom: 0;
}

.content-block p {
  margin: 0;
  color: #333;
  font-size: 1.9rem;
  line-height: 2;
  text-align: justify;
  text-indent: 2em;
}

.html-block ::v-deep p {
  margin: 0;
  color: #333;
  font-size: 1.9rem;
  line-height: 2;
  text-align: justify;
  text-indent: 2em;
}

.html-block ::v-deep .ql-align-center {
  text-align: center;
  text-indent: 0;
}

.html-block ::v-deep .ql-align-right {
  text-align: right;
  text-indent: 0;
}

.html-block ::v-deep .img-desc {
  color: #666;
  font-size: 1.6rem;
}

.html-block ::v-deep strong,
.html-block ::v-deep b {
  font-weight: 700;
}

.html-block ::v-deep a {
  color: #1385f5;
  text-decoration: none;
}

.content-block h2 {
  margin: 2.8rem 0 1.2rem;
  color: #222;
  font-size: 2.2rem;
  font-weight: 600;
  line-height: 1.8;
}

.content-block figure {
  margin: 2.8rem auto;
  text-align: center;
}

.content-block img {
  display: block;
  max-width: 100%;
  max-height: none;
  margin: 0 auto;
  object-fit: contain;
}

.content-block figcaption {
  margin-top: .8rem;
  color: #999;
  font-size: 1.6rem;
  line-height: 1.6;
}

.news-switch {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 3.2rem;
  padding: 1.8rem 0;
  color: #999;
  font-size: 1.8rem;
}

.switch-item {
  display: flex;
  align-items: center;
  max-width: 45%;
  cursor: pointer;
  transition: color .2s ease;
}

.switch-item:hover {
  color: #1385f5;
}

.switch-item.disabled {
  cursor: default;
  color: #c6c6c6;
}

.switch-item.disabled:hover {
  color: #c6c6c6;
}

.switch-next {
  justify-content: flex-end;
  text-align: right;
}

.switch-arrow {
  flex: 0 0 auto;
  color: #c6c6c6;
  font-size: 3.6rem;
  line-height: 1;
}

.switch-prev .switch-arrow {
  margin-right: 1rem;
}

.switch-next .switch-arrow {
  margin-left: 1rem;
}

.switch-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.empty-container {
  width: 100rem;
  max-width: calc(100% - 3.2rem);
  min-height: 52vh;
  margin: 0 auto;
  padding: 15rem 0 8rem;
  text-align: center;
}

.empty-container h1 {
  margin: 0 0 1.6rem;
  color: #1f2d3d;
  font-size: 3.4rem;
}

.empty-container p {
  margin: 0 0 2.8rem;
  color: #607080;
  font-size: 1.7rem;
}

.empty-container button {
  padding: 1.2rem 3.4rem;
  border: 0;
  border-radius: 2.2rem;
  background: linear-gradient(318deg, #0f81f4 0%, #37a4ff 100%);
  color: #fff;
  cursor: pointer;
  font-size: 1.6rem;
}

@media screen and (max-width: 76.8rem) {
  .detail-hero {
    padding: 9.6rem 0 2.4rem;
  }

  .detail-header h1 {
    font-size: 2.5rem;
  }

  .detail-container {
    padding: 2rem 0 5.6rem;
  }

  .news-content {
    padding: 2.4rem 1.8rem;
    border-radius: .8rem;
  }

  .content-block p {
    font-size: 1.8rem;
  }

  .content-block img {
    max-height: none;
  }

  .news-switch {
    display: block;
    margin-top: 2.4rem;
    padding: 1.2rem 0;
  }

  .switch-item {
    max-width: 100%;
    margin-bottom: 1.2rem;
  }

  .switch-next {
    justify-content: flex-start;
    text-align: left;
  }

  .switch-next .switch-text {
    order: 2;
  }

  .switch-next .switch-arrow {
    order: 1;
    margin-right: 1rem;
    margin-left: 0;
  }
}
</style>
